import storage from 'redux-persist/lib/storage'
import {persistReducer} from 'redux-persist'
import {InitAuthState} from '../../app/modules/auth'
import {vw_application_user} from 'openapi'

const initAuthState: InitAuthState = {
  authToken: '',
  user: undefined,
  loading: false,
  errorMessage: null,
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  // LoginWith2Fa: "[LoginWith2Fa] Action",
  SetLoading: '[LOADING] Info',
  SetErrorMessage: '[ERROR] Message',
  // GetInfo: "[getInfo] Action",
  // RequestToken: "[Request Token] Action",
  SetToken: '[Token User] Auth API',
  SetUser: '[Get User Info] Getting user inforation',
}

export const actions = {
  login: (requiresTwoFactor: boolean) => ({type: actionTypes.Login, payload: {requiresTwoFactor}}),
  // loginMfa: () => ({ type: actionTypes.LoginWith2Fa }),
  logout: () => ({type: actionTypes.Logout}),
  setLoading: (value: boolean) => ({type: actionTypes.SetLoading, payload: {value}}),
  // requestToken: (token: string) => ({ type: actionTypes.RequestToken, payload: { token } }),
  // fulfillInfo: (user: any) => ({ type: actionTypes.GetInfo, payload: { user } }),
  setErrorMessage: (error: string) => ({type: actionTypes.SetErrorMessage, payload: {error}}),
  setToken: (token: string, config?: any) => ({type: actionTypes.SetToken, payload: {token, config}}),
  SetUser: (user: vw_application_user) => ({type: actionTypes.SetUser, payload: {user}}),
}

// export const persistKey = 'v706-auth'
export const persistKey = 'root'

const persistConfig = {
  key: persistKey,
  storage,
  whitelist: ['config', 'errorMessage', 'loading', 'authToken'],
}

export const reducer = persistReducer(persistConfig, (state = initAuthState, action: any) => {
  switch (action.type) {
    case actionTypes.Login: {
      const {twoFactorRequired} = action.payload

      return {...initAuthState, loading: true, twoFactorRequired}
    }
    case actionTypes.SetErrorMessage: {
      const {error} = action.payload
      return {...initAuthState, errorMessage: error, loading: false}
    }
    case actionTypes.SetToken: {
      const {token} = action.payload

      return {...initAuthState, authToken: token, loading: false}
    }
    case actionTypes.SetUser: {
      const {user} = action.payload

      return {...initAuthState, user: user}
    }

    case actionTypes.SetLoading: {
      const {value} = action.payload

      return {...initAuthState, loading: value}
    }

    // case actionTypes.GetInfo: {
    //     const { user } = action.payload;

    //     return { ...initAuthState, user, loading: false };
    // }

    case actionTypes.Logout: {
      return {
        authToken: '',
        // user: undefined,
        loading: false,
        errorMessage: null,
        twoFactorRequired: false,
      }
    }

    default:
      return state
  }
})
